import classNames from "components/ui/classNames";
import type { ReactNode } from "react";

interface IPageHeadingProps {
  icon: ReactNode;
  iconContainerClassName?: string;
  title: ReactNode;
  titleClassName?: string;
  description: ReactNode;
}

export default function PageHeading({
  icon,
  iconContainerClassName,
  title,
  titleClassName,
  description,
}: IPageHeadingProps) {
  return (
    <header className="my-8 flex flex-col items-center space-y-4 text-center font-aeonik md:flex-row md:space-x-4 md:space-y-0 md:text-left">
      <div
        aria-hidden={true}
        className="rounded-full border border-gray-200 bg-white p-1 dark:border-transparent dark:bg-transparent"
      >
        <div
          className={classNames(
            iconContainerClassName,
            "inline-flex rounded-full border p-4 dark:border-transparent dark:bg-opacity-5 dark:squircle",
          )}
        >
          {icon}
        </div>
      </div>

      <div className="space-y-2 md:space-y-1 lg:space-y-0">
        <h1 className={classNames("m-0 text-2xl font-bold text-gray-600 dark:text-gray-200", titleClassName)}>
          {title}
        </h1>
        {/* https://stackoverflow.com/a/3910470 */}
        <p className="m-0 text-base font-normal leading-6 tracking-wide text-gray-500 dark:text-gray-400 md:text-base">
          {description}
        </p>
      </div>
    </header>
  );
}
